import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from './authentication/auth.guard';

const routes: Routes = [
  { path: '', canActivate: [AuthGuard], children: [
      { path: '', loadChildren: () => import('./main/main.module').then(m => m.MainModule)},
      { path: '', pathMatch: 'full', redirectTo: ''}
    ]
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
